import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './Popover.module.scss';

interface TitleSectionProps {
  text: string;
  onClose: (event: MouseEvent | React.KeyboardEvent<Element>) => void;
}
export const TitleSection: React.FC<React.PropsWithChildren<TitleSectionProps>> = ({ onClose, text }) => {
  return (
    <div className={styles['title-container']}>
      <div className={styles['title-content']}>
        <span className={styles['title-text']}>{text} </span>
        <button className={styles['title-close']} onClick={(e) => onClose(e.nativeEvent)}>
          <FontAwesomeIcon size={'lg'} icon={faTimes} />
        </button>
      </div>
      {/* <Divider /> */}
    </div>
  );
};

export const ContentSection: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['popover-content']}>{children}</div>;
};

export const ButtonsSection: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['buttons-content']}>{children}</div>;
};

export const StickyBottom: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['sticky-bottom']}>{children}</div>;
};

export const Scrollable: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['scrollable']}>{children}</div>;
};
